import * as React from 'react';
import { observer } from 'mobx-react';

import { Button } from 'shared/newComponents/buttons';
import { ButtonColor, ButtonSize } from 'shared/newEntities/components/Button';
import { ComponentType } from 'shared/entities/components/Component';
import { useTypedTranslation } from 'shared/entities/localization';
import { useChannelsModalStore } from 'stores/ChannelsModalStore';

import './ConnectChannelsFooter.modules.scss';

const ConnectChannelsFooter: React.FC = () => {
  const { t } = useTypedTranslation('newContainers');
  const { store } = useChannelsModalStore();
  const channelScenariosStore = store.channelScenariosStore;

  if (!channelScenariosStore) {
    return null;
  }

  return (
    <div styleName="connect-channels-footer">
      <Button
        size={ButtonSize.s}
        type={ComponentType.button}
        color={ButtonColor.blue}
        onClick={channelScenariosStore.save}
        disabled={
          !channelScenariosStore.hasChanges ||
          channelScenariosStore.savingStage.isLoading
        }
        isLoading={channelScenariosStore.savingStage.isLoading}
      >
        {t('ChannelsModal.Content.scenarioActions.connect')}
      </Button>
    </div>
  );
};

export default observer(ConnectChannelsFooter);
